import { EnvironmentProviders, Provider } from '@angular/core';

import { environment } from '@zeusm/environment';
import { provideApiService } from '@zeusm/shared/core/helpers';
import { AUTH_API, AuthApiMockService, AuthApiService } from '@zeusm/shared/session/auth';
import { USER_API, UserApiMockService, UserApiService, UserStore } from '@zeusm/shared/session/user';

const SESSION_STORES: (Provider | EnvironmentProviders)[] = [UserStore];
const SESSION_API_SERVICES: (Provider | EnvironmentProviders)[] = [
  {
    provide: AUTH_API,
    useClass: provideApiService(environment.useMocks, AuthApiMockService, AuthApiService),
  },
  {
    provide: USER_API,
    useClass: provideApiService(environment.useMocks, UserApiMockService, UserApiService),
  },
];

export const SESSION_INFRASTRUCTURE_PROVIDERS: (Provider | EnvironmentProviders)[] = [...SESSION_STORES, ...SESSION_API_SERVICES];
